import QRCode from "qrcode";
import { debugConsole } from "./debugConsole";

export const generateQRCode = async (
  text: string,
  size: number = 200,
): Promise<string> => {
  try {
    return await QRCode.toDataURL(text, {
      width: size,
      margin: 1,
      color: { dark: "#000000", light: "#FFFFFF" },
    });
  } catch (error) {
    debugConsole(error);
    return "";
  }
};

// export const generateQRCode = () => {
//   return null;
// };
